import { createSelector } from "reselect";
import { createAssign } from "robodux";
import { put } from "saga-query";

import { thunks } from "@apis";

const REPO_NAME = "persistorGuard";
export const persistorGuard = createAssign<any>({
  name: REPO_NAME,
  initialState: {
    email: "",
  },
});

export const setLastLoginEmail = thunks.create<string>(
  "setLastLoginEmail",
  function* (ctx, next) {
    yield* put(persistorGuard.actions.set({ email: ctx.payload }));
    yield* next();
  }
);

const selectListReportUis = (state: { [x: string]: any }) =>
  state[persistorGuard.name];

export const selectLastLoginEmail = createSelector(
  selectListReportUis,
  (state) => state.email
);
